// PasswordGenerator.js
import React, { useEffect, useState } from "react";
import { TextField, Button, Typography, Slider, Checkbox } from "@mui/material";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Generator Kata Sandi Acak dan Kuat - Buat Kata Sandi Kompleks dan Aman";
const DESCRIPTION = "Generator kata sandi kuat dan acak untuk semua akun Anda! Buat kata sandi kompleks dan sulit menggunakan kombinasi huruf, angka, dan simbol. Pilih antara 12 hingga 100 karakter untuk mendapatkan tingkat keamanan dan perlindungan maksimal untuk akun pribadi Anda";
const KEYWORDS = "generator kata sandi, kata sandi kompleks, kata sandi sulit, kata sandi acak, kata sandi kuat, generator kata sandi, kata sandi kuat, buat kata sandi, generator kata sandi acak, perlindungan akun, keamanan internet, keamanan data, kata sandi kuat, generator kata sandi acak, huruf, angka, dan simbol";
const OG_URL = "https://do-calculate.com/calculator/id/random-password-generator";
function PasswordGenerator() {
  const [passwordLength, setPasswordLength] = useState(8);
  const [includeLowercase, setIncludeLowercase] = useState(true);
  const [includeUppercase, setIncludeUppercase] = useState(true);
  const [includeNumbers, setIncludeNumbers] = useState(true);
  const [includeSymbols, setIncludeSymbols] = useState(true);
  const [excludeAmbiguous, setExcludeAmbiguous] = useState(true);
  const [excludeBrackets, setExcludeBrackets] = useState(true);
  const [noRepeatedChars, setNoRepeatedChars] = useState(false);
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordEntropy, setPasswordEntropy] = useState(0);
  const [error, setError] = useState("");
  useEffect(() => {
    generatePassword();
  }, [
    passwordLength,
    includeLowercase,
    includeUppercase,
    includeNumbers,
    includeSymbols,
    excludeAmbiguous,
    excludeBrackets,
    noRepeatedChars,
  ]);
  useEffect(() => {
    calculatePasswordEntropy();
    evaluatePasswordStrength();
  }, [generatedPassword]);
  const calculatePasswordEntropy = () => {
    let charsetSize = 0;
    const excludedChars = excludeAmbiguous ? "iIl1L|o0O'\";:., " : "";
    const excludedBrackets = excludeBrackets ? "[]<>()" : "";
    if (includeLowercase) {
      charsetSize += 26;
    }
    if (includeUppercase) {
      charsetSize += 26;
    }
    if (includeNumbers) {
      charsetSize += 10;
    }
    if (includeSymbols) {
      const allowedSymbols = "!@#$%^&*_+=-|~";
      const filteredSymbols = allowedSymbols
        .split("")
        .filter(
          (symbol) =>
            !excludedChars.includes(symbol) &&
            !excludedBrackets.includes(symbol)
        );
      charsetSize += filteredSymbols.length;
    }
    const patternEntropy = calculatePatternEntropy();
    const passwordEntropy = Math.log2(Math.pow(charsetSize, passwordLength));
    const repeatedCharacterEntropy = calculateRepeatedCharacterEntropy();
    setPasswordEntropy(
      Math.max(
        passwordEntropy + patternEntropy + repeatedCharacterEntropy,
        0
      ).toFixed(1)
    );
  };
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(generatedPassword);

    } catch (err) {
      console.error("Gagal menyalin: ", err);
    }
  };

  const calculatePatternEntropy = () => {
    const patterns = [
      /\d{2,}/,
      /[a-z]{2,}/,
      /[A-Z]{2,}/,
      /[^a-zA-Z0-9]{2,}/,
    ];
    let patternEntropy = 0;
    patterns.forEach((pattern) => {
      const matches = generatedPassword.match(pattern);
      if (matches) {
        const patternLength = matches.reduce(
          (total, match) => total + match.length,
          0
        );
        patternEntropy += Math.log2(patternLength);
      }
    });
    return -patternEntropy;
  };
  const calculateRepeatedCharacterEntropy = () => {
    const repeatedCharacters = generatedPassword.match(/(.)\1+/g);
    if (repeatedCharacters) {
      const repeatedCharactersCount = repeatedCharacters.reduce(
        (total, match) => total + match.length - 1,
        0
      );
      const uniqueCharacterCount = passwordLength - repeatedCharactersCount;
      return Math.log2(uniqueCharacterCount);
    }
    return 0;
  };
  const evaluatePasswordStrength = () => {
    if (passwordEntropy === 0) {
      setPasswordStrength("");
    } else if (passwordEntropy < 28) {
      setPasswordStrength("Sangat Lemah");
    } else if (passwordEntropy < 36) {
      setPasswordStrength("Lemah");
    } else if (passwordEntropy < 60) {
      setPasswordStrength("Baik");
    } else if (passwordEntropy < 128) {
      setPasswordStrength("Kuat");
    } else {
      setPasswordStrength("Sangat Kuat");
    }
  };
  const generatePassword = () => {
    let charset = "";
    if (includeLowercase) charset += "abcdefghijklmnopqrstuvwxyz";
    if (includeUppercase) charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    if (includeNumbers) charset += "0123456789";
    if (includeSymbols) charset += "!@#$%^&*()_+-=[]{}|;:,.<>?";
    if (excludeAmbiguous) {
      charset = charset.replace(/[iIl1L|o0O`'";:.,]/g, "");
    }
    if (excludeBrackets) {
      charset = charset.replace(/[(){}[\]<>]/g, "");
    }
    if (charset.length === 0) {
      setError(
        "Harap sertakan setidaknya satu kelompok karakter untuk kata sandi yang akan digunakan."
      );
      return;
    }
    if (noRepeatedChars && passwordLength > charset.length) {
      setError(
        "Tidak cukup karakter untuk membuat kata sandi ini. Harap sertakan lebih banyak kelompok karakter."
      );
      return;
    }
    let generatedPassword = "";
    for (let i = 0; i < passwordLength; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      generatedPassword += charset.charAt(randomIndex);
      charset = charset.replace(charset.charAt(randomIndex), "");
    }
    setGeneratedPassword(generatedPassword);
    setError("");
  };
  const handleSliderChange = (event, value) => {
    setPasswordLength(value);
  };
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    switch (name) {
      case "includeLowercase":
        setIncludeLowercase(checked);
        break;
      case "includeUppercase":
        setIncludeUppercase(checked);
        break;
      case "includeNumbers":
        setIncludeNumbers(checked);
        break;
      case "includeSymbols":
        setIncludeSymbols(checked);
        break;
      case "excludeAmbiguous":
        setExcludeAmbiguous(checked);
        break;
      case "excludeBrackets":
        setExcludeBrackets(checked);
        break;
      case "noRepeatedChars":
        setNoRepeatedChars(checked);
        break;
      default:
        break;
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Generator kata sandi adalah alat yang digunakan untuk membuat kata sandi acak dan kuat.
                  Tujuan penggunaan alat ini adalah untuk meningkatkan keamanan akun online Anda, karena kata sandi yang kuat sulit ditebak dan diretas.
                </p>
                <p>
                  Alat ini dapat membuat kata sandi yang aman, kuat, dan acak. Untuk memastikan keamanan, kata sandi dibuat sepenuhnya di halaman web tanpa dikirim melalui internet.
                </p>
                <p>
                  Manfaat menggunakan generator kata sandi: Perlindungan terhadap peretasan dengan menggunakan kata sandi yang kuat dan acak, keamanan data sensitif ditingkatkan dengan mengurangi kemungkinan kebocoran data Anda secara online saat menggunakan kata sandi yang sulit ditebak. Kemudahan mengingat karena generator kata sandi membuat kata sandi secara otomatis, mengurangi beban mengingat kata sandi yang kompleks.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-12">
                {generatedPassword && !error && (
                  <div className="mb-2">
                    <Typography
                      className="ltr"
                      fontSize="20px"
                      fontWeight="bold"
                      sx={{ wordWrap: "break-word", textAlign: "center" }}
                    >
                      {generatedPassword}
                    </Typography>
                    <Typography fontSize="18px">
                      Kekuatan kata sandi :{" "}
                      <span
                        style={{
                          color:
                            passwordStrength === "Sangat Lemah"
                              ? "rgb(255, 0, 0)"
                              : passwordStrength === "Lemah"
                                ? "rgb(255, 102, 0)"
                                : passwordStrength === "Baik"
                                  ? "rgb(102, 204, 102)"
                                  : passwordStrength === "Kuat"
                                    ? "rgb(51, 204, 51)"
                                    : "rgb(0, 153, 0)",
                        }}
                      >
                        {passwordStrength}
                      </span>
                    </Typography>
                    <Typography fontSize="18px" sx={{ mb: "15px" }}>
                      Entropi kata sandi : {passwordEntropy} bits
                    </Typography>
                    <div className="d-flex">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        fill="currentColor"
                        style={{ marginLeft: "5px" }}
                      >
                        <path d="M16 1H4c-1.1 0-2 .9-2 2v12h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                      </svg>

                      <Typography
                        onClick={handleCopy}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          color: "rgb(102, 204, 102)",
                          textDecoration: "underline",
                          fontSize: "18px",
                          width: "fit-content",
                          "&:hover": {
                            color: "rgb(23 158 23)",
                            textDecoration: "none",
                            cursor: "pointer",
                          },
                        }}
                      >
                        Salin kata sandi
                      </Typography>
                    </div>

                  </div>
                )}
                {error && (
                  <Typography
                    variant="body2"
                    color="error"
                    fontSize="16px"
                    sx={{ my: 2 }}
                  >
                    {error}
                  </Typography>
                )}
              </div>
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div
                  className="mb-3 mt-2 d-flex"
                  style={{ alignItems: "center" }}
                >
                  <label>Panjang kata sandi </label>
                  <TextField
                    value={passwordLength}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value !== "" && (value < 8 || value > 50)) {
                        value = Math.min(Math.max(value, 8), 50);
                      }
                      setPasswordLength(value);
                    }}
                    sx={{
                      width: "150px",
                      mr: "15px",
                      bgcolor: "#f9f9f9",
                      "&  .MuiFormHelperText-root.Mui-error": {
                        backgroundColor: "rgb(229, 230, 227) !important",
                        margin: 0,
                      },
                    }}
                    type="number"
                    InputProps={{
                      inputProps: {
                        min: 8,
                        max: 50,
                      },
                    }}
                    size="small"
                    color="success"
                  />
                </div>
                <div className="mb-2" style={{ width: "60%" }}>
                  <Slider
                    value={passwordLength}
                    onChange={handleSliderChange}
                    color="success"
                    sx={{ marginRight: "100px", marginLeft: "100px" }}
                    min={8}
                    max={50}
                    step={1}
                    marks={[
                      { value: 8, label: "8" },
                      { value: 20, label: "20" },
                      { value: 35, label: "35" },
                      { value: 50, label: "50" },
                    ]}
                  />
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={includeLowercase}
                    onChange={handleCheckboxChange}
                    name="includeLowercase"
                    color="success"
                  />
                  Sertakan huruf kecil (a-z)
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={includeUppercase}
                    onChange={handleCheckboxChange}
                    name="includeUppercase"
                    color="success"
                  />
                  Sertakan huruf besar (A-Z)
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={includeNumbers}
                    onChange={handleCheckboxChange}
                    name="includeNumbers"
                    color="success"
                  />
                  Sertakan angka (0-9)
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={includeSymbols}
                    onChange={handleCheckboxChange}
                    name="includeSymbols"
                    color="success"
                  />
                  {`Sertakan simbol (~!@#$%^&*()_+-=:;){/}[]?><)`}
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={excludeAmbiguous}
                    onChange={handleCheckboxChange}
                    name="excludeAmbiguous"
                    color="success"
                  />
                  {`Kecualikan karakter ambigu (iIl1L|o0O'";:.,)`}
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={excludeBrackets}
                    onChange={handleCheckboxChange}
                    name="excludeBrackets"
                    color="success"
                  />
                  {`Kecualikan tanda kurung ({}， []， <>， ())`}
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={noRepeatedChars}
                    onChange={handleCheckboxChange}
                    name="noRepeatedChars"
                    color="success"
                  />
                  Tidak ada karakter berulang
                </div>
                <div className="text-center">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={generatePassword}
                  >
                    Buat Kata Sandi
                  </Button>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Semua yang Perlu Anda Ketahui Tentang Kata Sandi:
              </div>
              <div className="info-section-body">
                <p>
                  Kata sandi biasanya merupakan rangkaian karakter yang dapat mencakup huruf, angka, dan simbol yang dapat digunakan untuk mengakses sesuatu, biasanya akun, dan mencegah orang lain mengaksesnya. Di era internet saat ini, kemungkinan besar kebanyakan orang memiliki pengalaman memiliki kata sandi untuk beberapa jenis akun. Oleh karena itu, penting untuk memahami cara membuat kata sandi yang kuat (atau menggunakan generator kata sandi) serta memahami cara mengambil langkah-langkah yang diperlukan untuk melindungi kata sandi.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Kekuatan Kata Sandi:</h2>
                </u>
                <br />
                <p>
                  Kekuatan kata sandi adalah ukuran seberapa efektif kata sandi terhadap tebakan atau serangan peretas. Meskipun bervariasi, biasanya kekuatan kata sandi merupakan perkiraan jumlah rata-rata upaya yang diperlukan seseorang untuk berhasil menebak kata sandi. Hal ini dipengaruhi oleh panjang kata sandi, kompleksitas, dan ketidakpastiannya. Misalnya, jika kata sandi mencakup nama seseorang, tanggal lahir, atau informasi pribadi lainnya yang biasanya tidak sulit ditemukan, kemungkinan kata sandi tersebut lemah. Selain kata sandi itu sendiri, kontrol keamanan yang tepat memainkan peran penting dalam mengurangi risiko pelanggaran keamanan.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Cara Membuat Kata Sandi yang Aman:
                  </h2>
                </u>
                <br />
                <p>
                  Kata sandi yang aman dapat dibuat dengan mengikuti aturan tertentu yang dirancang untuk meningkatkan keamanan kata sandi. Ini sebagian besar mencakup pembuatan kata sandi yang kuat, tetapi juga mencakup aspek lain seperti mengubah kata sandi secara berkala, serta kesadaran akan kata sandi umum dan menghindari penggunaannya (password, 123456, qwert...). Berikut adalah beberapa aturan yang dapat digunakan untuk membuat kata sandi yang kuat:
                  <br />
                  - Sertakan huruf kecil [a-z]
                  <br />
                  - Sertakan huruf besar [A-Z]
                  <br />
                  - Sertakan angka [0-9]
                  <br />
                  - Sertakan simbol [!@#$%^&*()...]
                  <br />
                  - Kecualikan kata-kata yang mencakup informasi pribadi pengguna <br />
                  - Kecualikan kata-kata yang ada dalam daftar hitam kata sandi - ada daftar hitam kata sandi yang dapat ditemukan online, atau mungkin perusahaan/lembaga lain memiliki daftar hitam kata sandi sendiri
                  <br />
                  - Kecualikan nama perusahaan/lembaga, serta singkatan nama
                  <br />
                  - Kecualikan kata sandi yang cocok dengan format umum seperti tanggal kalender, nomor plat, nomor telepon, atau format angka umum lainnya
                  <br />
                  Selain itu, banyak kebijakan kata sandi biasanya mencakup panjang minimum kata sandi karena umumnya, semakin panjang kata sandi, dan semakin bervariasi jenis karakter, semakin aman kata sandi.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Entropi Kata Sandi:</h2>
                </u>
                <br />
                <p>
                  Generator kata sandi juga menentukan entropi kata sandi, diukur dalam bit. Semakin tinggi entropi, semakin sulit menebak kata sandi. Dalam konteks serangan peretas (di mana setiap kemungkinan diuji), entropi kata sandi 100 bit memerlukan 2^100 upaya untuk menghabiskan semua kemungkinan. Namun, rata-rata, sekitar setengah dari kemungkinan ini perlu dihabiskan sebelum opsi yang benar ditemukan.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Cara Melindungi Kata Sandi Anda:
                  </h2>
                </u>
                <br />
                <p>
                  Melindungi kata sandi Anda sama pentingnya dengan membuat kata sandi yang kuat. Berikut adalah beberapa tindakan yang disarankan yang dapat Anda lakukan untuk membantu melindungi kata sandi Anda:
                  <br />- Jangan bagikan kata sandi Anda dengan orang lain - idealnya, pengguna harus menjadi satu-satunya orang yang mengetahui kata sandinya. Misalnya, bahkan jika Anda mempercayai orang yang Anda bagikan kata sandi, dan bahkan jika orang tersebut tidak memiliki niat jahat, mereka mungkin kurang berhati-hati daripada Anda dalam melindungi kata sandi Anda. Semakin banyak orang yang mengetahui kata sandi Anda, semakin besar kemungkinan informasi Anda dicuri oleh orang lain.
                  <br />
                  - Jangan gunakan kata sandi yang sama di berbagai situs web dan akun - meskipun mungkin lebih baik menggunakan kata sandi yang sama di berbagai situs web dan akun, ini tidak disarankan. Memiliki kata sandi yang sama untuk semua akun Anda, tidak peduli seberapa kuat kata sandinya, dapat berarti bahwa pelanggaran keamanan pada satu akun membahayakan integritas semua akun Anda. Menggunakan pengelola kata sandi dapat membantu Anda mengelola kata sandi dan akun Anda, serta meningkatkan keamanan dengan memungkinkan Anda menggunakan kata sandi yang berbeda untuk akun yang berbeda dengan lebih mudah.
                  <br />
                  - Ubah kata sandi Anda secara teratur - ini adalah tindakan lain yang dapat Anda lakukan yang juga merepotkan, tetapi secara teoritis dapat membantu menjaga keamanan akun Anda. Ini membantu dalam kasus di mana seseorang mungkin mengetahui kata sandi Anda, dan dapat mengaksesnya, tetapi mungkin tidak segera mencoba melakukan sesuatu yang berbahaya. Dalam kasus ini, mengubah kata sandi Anda akan membatasi periode waktu mereka dapat mengakses akun Anda, dengan asumsi mereka tidak dapat menentukan kata sandi baru.
                  <br />
                  - Jangan pernah menyimpan kata sandi Anda di perangkat publik - idealnya, cobalah untuk tidak menyimpan kata sandi sama sekali untuk mengurangi risiko orang mendapatkan akses yang tidak diinginkan ke akun Anda. Demikian pula, berhati-hatilah saat mengakses akun sensitif di jaringan publik yang tidak aman.
                  <br />- Jangan simpan daftar kata sandi Anda yang jelas yang mungkin dapat diakses oleh seseorang, baik fisik maupun elektronik - misalnya, catatan tempel di meja Anda yang berisi akun dan kata sandinya, atau dokumen Word di desktop bernama "kata sandi" yang berisi informasi untuk semua akun Anda, atau catatan di ponsel Anda dapat membuat Anda berisiko kehilangan kata sandi yang tidak perlu. Seperti disebutkan di atas, pertimbangkan untuk menggunakan pengelola kata sandi sebagai gantinya. Ponsel dan laptop dapat hilang atau dicuri. Idealnya, seseorang harus menggunakan pengelola kata sandi atau dapat mengingat kata sandi mereka untuk berbagai akun berdasarkan akun tertentu.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PasswordGenerator;